// extracted by mini-css-extract-plugin
module.exports = {"reminder-block":"eAh_1ujZHj","text-button":"_3xQg5T0QOT","tip":"_25ua-_SrKc"};